import { Collapse, CollapseProps, Tabs, TabsProps } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import FieldInputMoneyBuffer from '../../components/fieldInputMoneyBuffer';
import FieldUser from '../../components/fieldUser';
import { getKeyCollapse } from '../../functions';
import useAccessForTask from '../../hooks/useAccessForTask';
import { RootState } from '../../store';
import { ItemTaskType } from '../../types';

const TabsResource = () => {
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);
    const isAccessOwnerView = useAccessForTask(currentTask, ['schedule-task.owner.view']);

    const isAccessToOwner = useAccessForTask(currentTask, [
        'schedule-task.all.create',
        'schedule-task.all.edit',
        'schedule-task.all.manage',
        'schedule-task.owner.create',
        'schedule-task.owner.edit',
        'schedule-task.owner.manage',
    ]);

    const isAccessToAssignee = useAccessForTask(currentTask, [
        'schedule-task.all.create',
        'schedule-task.all.edit',
        'schedule-task.all.manage',
        'schedule-task.owner.create',
        'schedule-task.owner.edit',
        'schedule-task.owner.manage',
    ]);

    const isAccessMoney = useAccessForTask(currentTask, [
        'schedule-task.all.edit',
        'schedule-task.all.manage',
        'schedule-task.owner.create',
        'schedule-task.owner.edit',
        'schedule-task.owner.manage',
        'schedule-task.assignee.create',
        'schedule-task.assignee.edit',
        // 'schedule-task.assignee.manage',
    ]);

    const isAccessVisibleMoney = useAccessForTask(currentTask, ['schedule-task.assignee.manage']);

    const collapseWorkItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Workers',
            children: (
                <>
                    <FieldUser
                        label={'Assignee'}
                        name={'assignee_for_task'}
                        mode={'multiple'}
                        disabled={!isAccessToAssignee}
                        onlyForProject={currentTask?.project_id ? [currentTask.project_id] : []}
                    />
                    <FieldUser
                        label={'Owner'}
                        name={'owner_task_id'}
                        disabled={!isAccessToOwner}
                        onlyForProject={currentTask?.project_id ? [currentTask.project_id] : []}
                    />
                </>
            ),
            forceRender: true,
        },
        {
            key: '2',
            label: 'Counts',
            children: (
                <>
                    {(isAccessOwnerView || isAccessMoney) && (
                        <FieldInputMoneyBuffer
                            disabled={!isAccessMoney || isAccessVisibleMoney}
                            nameField={'value_labour'}
                            labelField={'Value Labour'}
                        />
                    )}
                </>
            ),
            forceRender: true,
        },
    ];

    const collapseMaterialsItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Materials',
            children: <></>,
            forceRender: true,
        },
        {
            key: '2',
            label: 'Counts',
            children: (
                <>
                    {(isAccessOwnerView || isAccessMoney) && (
                        <FieldInputMoneyBuffer
                            disabled={!isAccessMoney || isAccessVisibleMoney}
                            nameField={'value_material'}
                            labelField={'Value Material'}
                        />
                    )}
                </>
            ),
            forceRender: true,
        },
    ];

    const collapseCompaniesItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Companies',
            children: <></>,
            forceRender: true,
        },
        {
            key: '2',
            label: 'Counts',
            children: (
                <>
                    {(isAccessOwnerView || isAccessMoney) && (
                        <FieldInputMoneyBuffer
                            disabled={!isAccessMoney || isAccessVisibleMoney}
                            nameField={'value_other'}
                            labelField={'Value Other'}
                        />
                    )}
                </>
            ),
            forceRender: true,
        },
    ];

    const collapseEquipmentItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Equipments',
            children: <></>,
            forceRender: true,
        },
        {
            key: '2',
            label: 'Counts',
            children: (
                <>
                    {(isAccessOwnerView || isAccessMoney) && (
                        <FieldInputMoneyBuffer
                            disabled={!isAccessMoney || isAccessVisibleMoney}
                            nameField={'value_equipment'}
                            labelField={'Value Equipment'}
                        />
                    )}
                </>
            ),
            forceRender: true,
        },
    ];

    const tabsItems: TabsProps['items'] = [
        {
            key: '1',
            label: 'People',
            children: <Collapse defaultActiveKey={getKeyCollapse(collapseWorkItems)} ghost items={collapseWorkItems} />,
            forceRender: true,
        },
        {
            key: '2',
            label: 'Companies',
            children: (
                <Collapse
                    defaultActiveKey={getKeyCollapse(collapseCompaniesItems)}
                    ghost
                    items={collapseCompaniesItems}
                />
            ),
            forceRender: true,
        },
        {
            key: '3',
            label: 'Equipment',
            children: (
                <Collapse
                    defaultActiveKey={getKeyCollapse(collapseEquipmentItems)}
                    ghost
                    items={collapseEquipmentItems}
                />
            ),
            forceRender: true,
        },
        {
            key: '4',
            label: 'Materials',
            children: (
                <Collapse
                    defaultActiveKey={getKeyCollapse(collapseMaterialsItems)}
                    ghost
                    items={collapseMaterialsItems}
                />
            ),
            forceRender: true,
        },
    ];

    return (
        <Tabs defaultActiveKey="1" items={tabsItems} centered type="card" size={'small'} style={{ marginTop: 10 }} />
    );
};

export default React.memo(TabsResource);
